const mockMusicLinkUrlPartsData = [
  { id: 1, part: "solax", can_be_deleted: false, owner: "John Doe" },
  { id: 4, part: "ex", can_be_deleted: false, owner: "John Doe" },
  { id: 5, part: "sthx", can_be_deleted: false, owner: "John Doe" },
  { id: 6, part: "clanx", can_be_deleted: false, owner: "John Doe" },
  { id: 7, part: "slmx", can_be_deleted: false, owner: "John Doe" },
  { id: 8, part: "tcmdx", can_be_deleted: false, owner: "John Doe" },
  { id: 9, part: "soltx", can_be_deleted: false, owner: "John Doe" },
  { id: 10, part: "wave", can_be_deleted: true, owner: "John Doe" },
  { id: 11, part: "pulse", can_be_deleted: true, owner: "John Doe" },
  { id: 12, part: "beat", can_be_deleted: true, owner: "John Doe" },
  { id: 13, part: "echo", can_be_deleted: true, owner: "John Doe" },
  { id: 14, part: "vinyl", can_be_deleted: true, owner: "John Doe" },
  { id: 15, part: "groove", can_be_deleted: true, owner: "John Doe" },
];

export default mockMusicLinkUrlPartsData;
